/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Accordion, List, InputItem, Picker } from 'antd-mobile';
import { planDetail } from '@/services/saas/supervise';

function add(a, b) {
  var c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  // eslint-disable-next-line no-sequences
  return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) + mul(b, e)) / e;
}

function mul(a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split('.')[1].length;
  } catch (f) {}
  try {
    c += e.split('.')[1].length;
  } catch (f) {}
  return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c);
}

/** 督导评分组件 */
function SupervisionScore(props) {
  const { planOptions, handlePlanChange, handleNormChange, disabled, value, storeValue } = props;
  const [list, setList] = useState([]);
  const [template, setTemplate] = useState([]);
  const [selectValue, setSelectValue] = useState('');
  const [templateValue, setTemplateValue] = useState([]);
  const [totalScore, setTotalScore] = useState(0);
  const [obtaintTotalScore, setObtaintTotalScore] = useState(0);

  const getTemplate = async () => {
    let list = [];
    list = planOptions.map((item) => {
      return {
        label: item.planName,
        value: item.id,
      };
    });
    setTemplate(list);
    setSelectValue(value ? value : list[0].value);
    getTemplateDetail(value ? value : list[0].value);
    setTemplateValue([value ? value : list[0].value]);
  };

  const getTemplateDetail = async (value) => {
    let arr = [],
      obj = {};
    const resp = await planDetail({ id: value });
    if (resp && resp.success) {
      const data = resp.data.planTypeList;
      let ts = 0,
        ots = 0;
      for (let i = 0; i < data.length; i++) {
        let sumNum = 0;
        arr.push({
          id: data[i].id,
          title: '（' + data[i].score + '分）' + data[i].planTypeName,
          sum: data[i].score,
          score: 0,
          children: [],
        });

        if (data[i].planIndexList.length > 0) {
          let childList = data[i].planIndexList;
          for (let j = 0; j < childList.length; j++) {
            sumNum += childList[j].score;
            obj[childList[j].id] = storeValue[childList[j].id] ? storeValue[childList[j].id] : 0;
            ots = add(ots, parseFloat(obj[childList[j].id]));
            arr[i].children.push({
              id: childList[j].id,
              title: '(' + childList[j].score + '分)' + childList[j].name,
              sum: childList[j].score,
              score: storeValue[childList[j].id] ? storeValue[childList[j].id] : 0,
            });
          }
        }
        arr[i].sum = sumNum;
        arr[i].title = '（' + sumNum + '分）' + data[i].planTypeName;
        ts += sumNum;
      }
      setList(arr);
      setTotalScore(ts);
      setObtaintTotalScore(ots);
    }
    handleNormChange(obj);
  };

  const onChange = (key, index, x) => {
    let flag = true,
      _len = key.length,
      spotIndex = key.indexOf('.'),
      splitlen = key.split('.').length - 1,
      obj = {},
      ots = 0;
    const _list = [...list];
    for (let i = 0; i < key.length; i++) {
      if ('1234567890.'.indexOf(key[i]) === -1) {
        flag = false;
      }
    }
    if (key === '' && (index || index === 0) && (x || x === 0)) {
      _list[index].children[x].score = 0;
      setList(_list);
      return;
    }
    if (
      !flag ||
      key.indexOf('.') === 0 ||
      (spotIndex !== -1 && _len - 1 - spotIndex > 2) ||
      splitlen > 1
    ) {
      return;
    }
    if ((index || index === 0) && (x || x === 0)) {
      if (parseFloat(key) <= _list[index].children[x].sum) {
        if (key.indexOf('0') === 0 && key.indexOf('.') === -1) {
          _list[index].children[x].score = parseFloat(key);
        } else {
          _list[index].children[x].score = key;
        }
        setList(_list);
      } else if (parseFloat(key) > _list[index].children[x].sum) {
        list[index].children[x].score = list[index].children[x].sum;
        setList(_list);
      }
    }
    for (let item of _list) {
      for (let temp of item.children) {
        obj[temp.id] = temp.score;
        ots = add(ots, parseFloat(temp.score));
      }
    }
    setObtaintTotalScore(ots);
    handleNormChange(obj);
  };

  useEffect(() => {
    if (planOptions.length > 0) {
      getTemplate();
    }
  }, [planOptions]);

  const listRef = useRef();

  return (
    <div className="supervise-score" ref={listRef}>
      <div className="supervise-score-content">
        <div className="supervise-score-template">
          {template.length > 0 ? (
            <Picker
              title="选择评分模板"
              data={template}
              cols={1}
              disabled={disabled}
              value={templateValue}
              onOk={(value) => {
                setSelectValue(value[0]);
                getTemplateDetail(value[0]);
                setTemplateValue(value);
                handlePlanChange(value[0]);
              }}
            >
              <div className="supervise-score-template-text">
                <span>
                  {template.map((item) => {
                    return item && item.value === selectValue ? item.label : '';
                  })}
                </span>
              </div>
            </Picker>
          ) : null}
          <div className="total-score">
            <label>
              总分：
              <span>
                <i>{obtaintTotalScore}</i>/{totalScore}
              </span>
            </label>
          </div>
        </div>
        {list.length > 0 ? (
          <Accordion defaultActiveKey={list[0] ? list[0].id : '0'} className="my-accordion">
            {list.map((item, index) => {
              return (
                <Accordion.Panel header={item.title} key={item.id}>
                  <List className="my-list">
                    {item.children.map((m, x) => {
                      return (
                        <List.Item key={m.id}>
                          <p>{m.title}</p>
                          <InputItem
                            defaultValue={m.score}
                            value={m.score}
                            placeholder=""
                            labelNumber={3}
                            disabled={disabled}
                            onChange={(key) => {
                              onChange(key, index, x);
                            }}
                          >
                            评分：
                          </InputItem>
                        </List.Item>
                      );
                    })}
                  </List>
                </Accordion.Panel>
              );
            })}
          </Accordion>
        ) : null}
      </div>
    </div>
  );
}

export default SupervisionScore;
